module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_summer_courses_de-ecb5885836d34dd129b0a2cffa59436d.png";